import React, { useState } from "react";
import {
  TextField,
  Icon,
  InputAdornment,
  IconButton,
  Tooltip,
} from "@mui/material";
import { FileCopy, Check, VisibilityOff, Visibility } from '@mui/icons-material';
import classNames from "classnames";
import styles from "./styles";

const Text = (props) => {
  const { field, values = {} } = props;
  const [copied, setCopied] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const classes = styles();

  const copyThat = () => {
    document.getElementById(`textfield_copyable_${field.key}`).select();
    document.execCommand("copy");
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 3000);
  };

  return (
    <>
      <TextField
        type={field.type !== 'password' ? field.type : showPassword ? "text" : "password" }
        required={(field.visible && field.required) || false}
        error={props.fieldErrors[field.key] ? true : false}
        autoComplete={
          props.mode === "Add" && field.type === "password"
            ? "new-password"
            : props.mode === "Edit"
            ? ""
            : "off"
        }
        key={field.key}
        id={`textfield_${field.key}`}
        label={field.label}
        slotProps={{ input: {
          min: field?.min || 0,
          max: field?.max,
          tabIndex: 1,
          maxLength: field.maxLength,
          step: "any",
        } }}
        style={field.big && { minWidth: 325 }}
        onChange={(e) => props.onChange(field, e.target.value)}
        value={props.fieldValues[field.key] || field.value || ""}
        defaultValue={values[field.key] || field.value}
        hidden={!field.visible}
        // helperText={props.fieldErrors[field.key] ? props.fieldErrors[field.key] : <span dangerouslySetInnerHTML={{__html: '&nbsp;'}} />}
        helperText={
          props.fieldErrors[field.key]
            ? props.fieldErrors[field.key]
            : props?.field?.helperText
            ? props.field.helperText
            : undefined
        }
        variant="outlined"
        onBlur={(e) => {
          props.onChange(field, e.target.value?.trim())
          props.validate(field)
      }}
        onKeyDown={(e) => {
          if (
            field.type === "number" &&
            (e.key === "-" || e.key === "+" || e.key === "e")
          ) {
            e.preventDefault();
          } else if (field.type === "number" && e.key === ".") {
            if (field?.isInteger) {
              e.preventDefault();
            }
          }
        }}
        fullWidth
        disabled={field.disabled}
        slotProps={{ inputLabel: { shrink:
            props.fieldValues[field.key] || field.type === "date"
              ? true
              : false, }, input: {
          endAdornment: field.copyable ? (
            <InputAdornment style={{ cursor: "pointer" }} position="end">
              <Tooltip
                placement="top"
                size="large"
                title={copied ? "Copied" : "Copy"}
                aria-label="add"
              >
                {copied ? (
                  <Check style={{ color: "#44cd44" }} />
                ) : (
                  <FileCopy color="primary" onClick={copyThat} />
                )}
              </Tooltip>
            </InputAdornment>
            ) : field.password ? (
              <InputAdornment className={classNames(classes.passwordIcon,classes.visibility)} position="end" onClick={()=>setShowPassword(!showPassword)}>
                    {showPassword ? <VisibilityOff /> : <Visibility />}
              </InputAdornment>
          ) : null,
        } }}
        className="mb-3"
      />
      {field.info && (
        <span
          style={{
            fontSize: 11,
            display: "block",
            marginTop: "-10px",
            marginLeft: 5,
            marginBottom: 10,
          }}
          dangerouslySetInnerHTML={{ __html: field.info }}
        />
      )}
      <input
        value={props.fieldValues[field.key] || field.value || ""}
        readOnly
        style={{ position: "fixed", top: "-1000px" }}
        id={`textfield_copyable_${field.key}`}
      />
    </>
  );
};

export default Text;
